import React, { createContext, ReactNode, useContext, useState } from 'react';

interface SearchBarProps {
  value: string;
  focused: boolean;
  active: boolean;
  setValue: (newValue: string) => void;
  setActive: (activeValue: boolean) => void;
  setFocused: (focusedValue: boolean) => void;
}

const SearchBarContext = createContext<SearchBarProps>({
  value: '',
  focused: false,
  active: false,
  setValue: () => {},
  setActive: () => {},
  setFocused: () => {},
});

export const useSearchBarContext = () => useContext(SearchBarContext);

type SearchBarProviderType = {
  children: ReactNode;
};

export const SearchBarProvider = ({ children }: SearchBarProviderType) => {
  const [value, updateValue] = useState<string>('');
  const [focused, updateFocused] = useState<boolean>(false);
  const [active, updateActive] = useState<boolean>(false);

  const setValue = (newValue: string) => {
    updateValue(newValue);
  };

  const setActive = (activeValue: boolean) => {
    updateActive(activeValue);
  };

  const setFocused = (focusedValue: boolean) => {
    updateFocused(focusedValue);
  };

  return (
    <SearchBarContext.Provider
      value={{ value, setValue, active, setActive, focused, setFocused }}
    >
      {children}
    </SearchBarContext.Provider>
  );
};
